module.exports = __webpack_public_path__ + "static/media/Beiras.1a1e156e.svg";